<template>
  <div>
    <div class="project-dynamic" v-if="!!total">
      <div class="title">楼盘动态</div>
      <div class="dynamic-wrap">
        <div class="step">

          <div v-if="dynamicList.length > 3 && !isWatchMore">
            <div  :key="i" v-for="(sub, i) in 3">
              <div class="point"></div>
              <div class="line" v-if="i < dynamicList.length -1"></div>
            </div>
          </div>

          <div v-else>
            <div :key="i" v-for="(sub, i) in dynamicList">
              <div :key="i">
                <div class="point"></div>
                <div class="line" v-if="i < dynamicList.length -1"></div>
              </div>
            </div>
          </div>

        </div>
        <div class="content">
          <template v-for="(item, index) in dynamicList">
            <dynamic-com class="dynamic" :key="index" v-if="index < 3 || isWatchMore" :info="item"></dynamic-com>
          </template>
        </div>
      </div>
      <div class="watch-more" v-if="total > 3" @click="isWatchMore = !isWatchMore">{{watchMoreText}}</div>
    </div>
    <div class="project-dynamic" v-else>
      <div class="title">楼盘动态</div>
      <div class="noData">暂无数据</div>
    </div>
  </div>
</template>

<script>
import DynamicCom from './dynamicCom.vue'
export default {
  name: 'project-dynamic',
  components: {
    DynamicCom
  },
  props: {
    projectCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dynamicList: [],
      total: 0,
      isWatchMore: false
    }
  },
  computed: {
    watchMoreText () {
      return this.isWatchMore ? '收起' : `查看所有动态（${this.total}）`
    }
  },
  mounted () {
    this.getDynamic()
  },
  methods: {
    getDynamic () {
      let params = {
        projectCode: this.projectCode,
        limit: 100
      }
      this.$api.getDynamic(params).then(res => {
        if (res.code === 200) {
          this.dynamicList = res.data && res.data.list
          this.total = res.data && res.data.total
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .title{
    @include font24(bold, #333333);
    margin: 52px 0 16px 0;
  }
  .noData{
    width: 126px;
    height: 19px;
    font-size: 14px;
    font-family: MicrosoftYaHeiSemilight;
    color: #B4A995;
    line-height: 19px;
    margin: auto;
    padding: 100px 50px;
  }
  .dynamic-wrap{
    margin: 24px 0;
    font-size: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .step{
      width: 1%;
      margin-top: 5px;
      .point{
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #BDA26C;
      }
      .line{
        width: 1px;
        height: 151px;
        background: #FFF0D3;
        margin-left: 3px;
      }
    }
    .content{
      width: 96%;
    }
    .dynamic{
      margin-top: 25px;
    }
    .dynamic:first-child{
      margin-top: 0;
    }
  }
  .watch-more{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #E6E6E6;
    cursor: pointer;
  }
</style>
